<style>
.headline {
  display: flex;
  justify-content: space-between;
}
</style>
<template>
  <div class="col-12">
    <div class="p-4 mb-4 bg-white mr-2 border rounded shadow">
      <div class="headline">
        <div>
          <b>
            <span v-html="article.title"></span>
          </b>
        </div>
        <div>
          {{ releaseTime(article.release_time) }}
        </div>
      </div>
      <div>
        <span v-html="article.article"></span>
      </div>
      <div v-if="unread && article.read_type == 2">
        <hr class="mt-4" />
        <v-button
          class="btn-primary btn"
          :working="reading"
          @click="read(article.id)"
        >
          <small>Als gelesen makieren</small>
        </v-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateTimeHtml } from "@/js/date";
export default {
  props: {
    article: {
      required: true,
      type: Object
    },
    unread: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      news: {},
      reading: false
    };
  },
  methods: {
    read(articleId) {
      this.reading = true;
      this.$http
        .post(`/api/v1/news/${articleId}/mark-as-read`)
        .then(() => {
          this.$emit("article_read", articleId);
          this.$store.commit("user/removeUnreadNews");
        })
        .finally(() => {
          this.reading = false;
        });
    },
    releaseTime(time) {
      return getDateTimeHtml(time);
    }
  }
};
</script>
